// @generated by TypeGen from LogbookModel/Status/MonitorStatus.swift - DO NOT EDIT

export interface IMonitorStatusData {
}

export interface IAnchorDepthConfig {
  warning?: number;
  alarm?: number;
}

export interface IAnchorFixedRadiusConfig {
  warning?: number;
  alarm?: number;
}

export interface IAnchorMonitorData {
  monitorWind: boolean;
  originLat: number;
  originLng: number;
  method?: IAnchorWatchMethod;
  fixedRadius?: IAnchorFixedRadiusConfig;
  rodeScope?: IAnchorRodeScopeConfig;
  sector?: IAnchorSectorConfig;
  depth?: IAnchorDepthConfig;
}

export interface IAnchorRodeScopeConfig {
  rode?: number;
  depth?: number;
  boatLength?: number;
  warning?: number;
  alarm?: number;
}

export interface IAnchorSectorConfig {
  warning?: number;
  alarm?: number;
  bearingFrom?: number;
  bearingTo?: number;
}

export interface IAnchorWatchSettings {
  monitorWind?: boolean;
  method?: IAnchorWatchMethod;
  fixedRadius?: IAnchorFixedRadiusConfig;
  rodeScope?: IAnchorRodeScopeConfig;
  sector?: IAnchorSectorConfig;
  depth?: IAnchorDepthConfig;
}

export interface IDepthMonitorData {
}

export enum IAnchorWatchMethod {
  fixedRadius = "fixedRadius",
  rodeScope = "rodeScope",
  sector = "sector",
}

export enum IMonitorStatusType {
  anchor = 1,
  depth = 2,
}
